import { useEffect } from "react";
import { useLang } from "../i18n";

const SITE = "https://amazonico3000.br.com";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ page, image = "/og-image.jpg" }) => {
  const { t } = useLang();
  const s = t.seo[page];

  useEffect(() => {
    if (!s) return;
    const path = page === "home" ? "/" : page === "patent1" ? "/brevetti/etichetta-intelligente"
      : page === "oregano" ? "/brevetti/oregano-scan"
      : page === "fashion" ? "/moda-lusso" : `/${page}`;
    const url = `${SITE}${path}`;
    document.title = s.title;
    setMeta("name", "description", s.description);
    setMeta("property", "og:title", s.title);
    setMeta("property", "og:description", s.description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${SITE}${image}`);
    setMeta("name", "twitter:title", s.title);
    setMeta("name", "twitter:description", s.description);
    setMeta("name", "twitter:image", `${SITE}${image}`);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [s, page, image]);

  return null;
};
